// 根据该模块下的个文件名，来做归类区分：
const en = {
	group: {
		groupManagement: 'Website Group Management',
		omniGroupManagement: 'Group Management',

		CREATEGROUP: 'CREATE GROUP',
		website: 'Website',
		addWebsite: 'Add website',
		detail: 'Detail',
		noWebsite: 'Please go to add a website',
		store: 'Store',
		noStore: 'Please go to add a store',

		groupName: 'Group',
		cancel: 'Cancel',
		create: 'Create',
		singleAdd: 'Add a website',
		batchAdd: 'Batch add websites',
		batchAddTittle: 'Batch add websites',
		label: 'Upload your batch file',
		download: 'Download template',
		add: 'Add',
		message: 'File not uploaded'
	},
	groupDetail: {
		settlementCurrency: 'Settlement Currency',
		searchStoreName: 'Search website name',
		omniSearchStoreName: 'Search website/store name',

		index: 'Index',
		storeName: 'Website',
		omniStoreName: 'Store/Website',
		accId: 'Acc ID',
		omniAccId: 'Acc ID',
		storeUrl: 'URL',
		storeType: 'Store Type',
		action: 'Action',
		detail: 'Detail',
		modifyGroupName: 'Modify Group Name',
		groupName: 'Group',
		comfirm: 'Comfirm',
		edit: 'Edit',
		copy: 'Copy',
		message: 'Modify group name successfully!'
	},
	webManagement: {
		noWebsite: 'You have not added a website yet.',
		addWebsite: 'Add a Website',
		pleaseSubmitName: 'Please submit identity verification first',
		needSubmitName: 'Please submit identity verification before adding a website',
		groupNeedKYC: 'Please submit identity verification before adding a group',
		submitName: 'Submit identity verification materials',
		contact: 'Contact Customer Service',
		contactToAdd: 'Contact customer service to add new website',
		noSuportAddBySelf: 'We do not support to add websites independently now. Please contact customer service who will guide you to submit the materials. Sorry for the inconvenience.',
		visible: 'Visible',
		hidden: 'Hidden ',
		storeNameUrl: 'Search website name / website url',
		hideWebsite: 'Hide the website',
		delete: 'Delete',
		hideTip: 'Once you hide the website, it will disapear in the list. If you want to see the website agian, you can click <i  class="el-input__icon el-icon-search"></i> icon beside the search bar to see the hidden websites.',
		hide: 'Hide',
		cancel: 'Cancel',
		deleteTip: 'Delete the website',
		sureDelete: 'Are you sure to delete the website?',
		unHide: 'Unhide the website',
		unHideReason: 'Are you sure to unhide the website?',
		hideReason: 'The reason you hide it',
		success: 'The operation was successful',
		confirm: 'Comfirm',
		bindShopify: 'Link to Shopify',
		unBindShopify: 'Unlink to Shopify',
		unlinkText: 'Unlinked to Shopify. Please install PingPong Connect App on Shopify portal to sync logistics inforamtion automatically.',
		linkIndependent: 'Link to independent',
		unlinkIndependent: 'Unlink independent',
		domain: 'Enter your domain',
		appToken: 'Enter your App Token',
		independent: 'Independent Website',
		linkStatus: 'Linked Status',
		webName: 'Website',
		webUrl: 'Website URL',
		onlyShopify: 'Now, only Shopify/Woocommerce/Shoplazza supported linking to platform, Other platforms are in development.',
		linksuccess: 'Link successfully',
		linkedTooltip: 'Linked to your %{website} account: %{host}',
		linkedTooltipWithStatus: 'Logistics linked. Linked to your %{website} account: %{host}',
		unlinkBodyText:
			'<p>Unlink <b>%{storeName}</b> from %{website}?</p><p>The system will no longer get your logistics information automatically after unlinking.</p>',
		unlinkBodyTextForWebsite:
			'<p>Unlink website <b>%{storeName}</b> from %{website}?</p><p>The system will no longer get your logistics information automatically after unlinking.</p>',
		linkBodyText:
			'<p>Once you link <b>%{storeName}</b> to %{website}, the system can get logistics information automatically, and you do not need to upload it manually.</p>',
		linkBodyTextForWebsite:
			'<p>Once you link website <b>%{storeName}</b> to %{website}, the system can get logistics information automatically, and you do not need to upload it manually.</p>',
		linkSuccessBodyText:
			'<p>You have linked <b>%{storeName}</b> to %{website}, and the system will get your logistics information automatically.</p>',
		linkSuccessMessage: 'Link successfully',
		unlinkSuccessMessage: 'Unlink successfully',
		accIdLabel: 'Acc ID',
		consumerKeyLabel: 'Consumer Key:',
		consumerSecretLabel: 'Consumer Secret:',
		commentWithResubmit: '%{comment}, %{tip}',
		allWebsiteOption: 'All',
		linkedStatusUnlinked: 'Unlinked',
		linkedStatusLinked: 'Linked',
		searchResultText: 'There are %{total} results with keyword "%{keyword}"',
		searchSuggestText: 'Couldn\'t find your website? Try to find it in <b>hidden websites</b>',
		autoUpload: 'Auto Upload',
		wooTip: 'Here is the address WooCommerce assigned to you. This address is for store authorization. Please fill it out correctly',
		require: 'Require',
		applePayDomainVerify: 'Apple Pay Domain Verification',
		applePayVerifiedTips: 'Apple Pay has been verified for this website',
		applePayDomainDesc: 'This step can be skipped if you are using PingPong\'s hosted payment page or payment links. Other integration methods, such as embedded checkout or Pay button integration, require domain verification before Apple Pay can be supported.',
		applePayStep1Title: 'Step 1: Download the verification file',
		applePayStep1Desc: 'Download the domain verification file provided by Apple. This file is used to prove that you have control over the domain.',
		applePayDownloadVerifyFile: 'Download verification file',
		applePayStep2Title: 'Step 2: Upload the file to your website',
		applePayStep2Desc: 'Upload the downloaded verification file to the specified path of your website. Apple will verify your domain ownership by accessing this path. Please ensure all websites displaying Apple Pay upload this file.',
		applePayUploadPath: 'Upload path: your-domain/.well-known/apple-developer-merchantid-domain-association',
		applePayStep3Title: 'Step 3: Verify your domain',
		applePayStep3Desc: 'Add the domain that has completed file upload in Step 2 and verify it. After successful verification, this domain can use Apple Pay on your website or app.',
		applePayAddDomain: 'Add domain',
		applePayVerifiedDomain: 'Verified domains',
		applePayDomainVerifySuccess: 'Domain verification succeeded',
		applePayDomainVerifyFail: 'Domain verification failed',
		applePayDomainInvalid: 'Please enter a valid domain',
		deleteApplePayDomainTip: 'This action will delete the verified domain %{domain}. Do you wish to continue?',
		deleteApplePayDomainTipTitle: 'Prompt'
	},
	addWebDialog: {
		addWebsite: 'Add a Website',
		webSiteName: 'Website Name',
		writeSiteName: 'Please fill in the website name',
		websiteUrl: 'Website URL',
		storeLink: 'Store link on Platform.',
		storeLinkPlaceholder: 'Links to stores on Amazon, eBay and other platforms',
		writeWebsiteUrl: 'Please fill in the domain name of website homepage',
		backHome: 'Back to homepage',
		title: 'Website not found?',
		desc: 'If your website cannot be found, please contact customer service.',
		contactText: 'Contact Customer Service: pp@pingpongx.com',
		cancel: 'Cancel',
		add: 'Add',
		cancelAdd: 'Cancel Adding a Website',
		cancelFont: 'You haven\'t added a website at present. It might affect your review progress if you cancel. Are you sure to do it?',
		secondCancelFont: 'You have not submitted yet. Do you want to continue editing？',
		yes: 'YES',
		no: 'NO',
		closePage: 'Close Page',
		confirm: 'Confirm'
	},
	addStore: {
		tradeType: 'Trade type',
		tradeTypeOfWebsite: 'Trade type of website',
		submitWebsite: 'Submit website review',
		omniSubmitWebsite: 'Website Management',
		report: 'Review Report',
		storeName: 'Store name',
		group: 'Website Group',
		omniGroup: 'Group',
		routeWebsiteGroup: 'Go to Website Group',
		omniRouteWebsiteGroup: 'Go to Group',
		omniKnownGroupTip: 'Know more about  Group Management',
		knownGroupTip: 'Know more about Website Group Management',
		knownGroupTipText: 'Website grouping can be used to isolate permissions for your company\'s regions, businesses, etc., merge and analyze data from multiple websites, etc. If not needed, default management will be used.',
		omniKnownGroupTipText: 'Group management can be used to isolate permissions for your company\'s regions, businesses, etc., merge and analyze data from multiple websites/store, etc. If not needed, default management will be used.',

		applicationForm: 'Application form',
		applicationFormDesc: 'Please download and fill out the application form, sign it, and upload it.',
		businessType: 'Business Type',
		pleaseSelect: 'Please select',
		noFlowNoHistort: 'There are no transactions on the website, but has Amazon/eBay stores operation history.',
		hasFlowOrHasHistory: 'There is already a transaction history for the website/App.',
		websiteFlow: 'Website journal',
		independentWebsite: 'Independent Website',
		websiteUrl: 'Website URL',
		summaryReport: 'latest 3~6 months of【credit card transaction processing statement】',
		submitReport: "For example: PayPal, Stripe, google Pay or other payment service provider's statement, which can manifest monthly transaction volume, chargeback rate, refund rate, etc.",
		picture: 'Picture',
		fitFiels: 'EXCEL or PDF',
		bankStatement: 'latest 3~6 months of 【transaction processing statement】on Amazon, eBay, etc',
		ifFirstBussiness: 'For example: Amazon statement',
		websiteUrlProvide: 'Website domain name registration',
		websiteUrlProvideDesc: 'Please provide website domain name purchase records and other information, including specific domain name, domain name purchaser, expiration date, etc.',
		submitMes: 'Submit the website information',
		cancel: 'Cancel',
		getFail: 'Failed to get the information, please contact the administrator',
		pleaseSubmit: 'Please upload',
		relevantDocs: 'Relevant Documents',
		closeField: 'Related documents',
		submitSuccess: 'Submit successfully',
		submitFail: 'Failed to submit, please try again',
		checking: 'Failed to submit, please try again',
		checkPass: 'Your website has been approved.',
		checkFail: 'The information of your website is not approved for lack of data or wrong information. Please submit again.',
		checkNotFit: 'Unfortunately, you are not qualified at present.',
		additional: 'Additional information',

		pleaseUploadFlow: 'Please upload the bank statement',
		pleaseWriteName: 'Please fill in the store name, The maximum support is 240 characters.',
		pleaseWriteUrl: 'Please fill in the website URL, The maximum support is 240 characters.',
		pleaseWriteLink: 'Please fill in the store link on Platform.',
		pleaseWriteLinkRule: 'The maximum support is 240 characters.',
		_independentWebsite: 'Please fill in the independent website',
		pleaseUploadApplication: 'Please Application form',
		pleaseSelectType: 'Please select the type of website',
		pleaseUploadFlowWeb: 'Please upload the flow statement of your website',
		pleaseMoneyReport: 'Please upload the financial statement.',
		pleaseUploadBild: 'Please upload the bank statement.',
		pleaseUploadProvide: 'Please upload the prove of website domain name registration',
		searchSuccess: 'Query successfully',
		addSuccess: 'Congratulations, the site was successfully added',
		addFailed: 'Unfortunately, add failed',
		inLength: '2 to 100 characters in length',
		pleaseSelectGroup: 'Please fill in the affiliated group',
		bankAccountInfo: 'Please upload',
		warnTip: [
			'Please ensure that your company meets the following requirements:',
			'1) Subject requirements: Mainland/Hong Kong/Europe/United States companies (non individual);',
			'2) Experienced in cross-border e-commerce, such as an independent website operator or transitioned from a big seller in platform to an independent website;',
			'3) Having a foundation in cross-border practice: monthly transaction amount should be no less than $100,000, including but not limited to big seller, PayPal, and other acquiring transactions;',
			'4) Controllable chargeback, with CB rate less than or equal to 1%;',
			'5) Non-defective business models such as site groups, imitation goods, and non-delivery.'
		],
		transactionHistory: 'Transaction History',
		transactionHistoryTip: "Platform's historical transaction proof, 6-12 months of credit card transaction statements (actually occurring on the platform). Examples: PayPal or other payment service provider statements, transaction details showing monthly volume, chargeback rate, fraud rate, refund rate, etc.",
		financialDoc: 'Financial Documentation (Optional)',
		financialDocTip: "Proof of company's financial.",
		websiteDoc: 'Domain Certificate',
		websiteDocTip: 'Including key information: Full domain name, registrant details, registration date, expiration date, registrar information',
		pci: 'PCI Compliance',
		pciTip: 'Payment Card Industry Data Security Standard (PCI DSS) compliance documentation',
		dueDiligence: 'Due Diligence',
		dueDiligenceTip: "Platform's submerchant review standards/policies and due diligence process.",
		prohibitedItems: 'Prohibited Items List',
		prohibitedItemsTip: "Platform's list of prohibited and restricted items.",
		disputeProcedures: 'Dispute Procedures',
		disputeProceduresTip: "Platform's dispute investigation procedures or consumer complaint handling mechanism.",
		riskMonitoring: 'Risk Monitoring',
		riskMonitoringTip: "Platform's risk control mechanisms, including but not limited to: <br/>(1) Written risk monitoring policies and procedures <br/>(2) Daily seller monitoring <br/>(3) Security deposit policies <br/>(4) Seller reward/penalty system (including removal process) <br/>(5) Suspicious transaction reporting",
		required: 'Please upload files'
	},
	webDetail: {
		webMan: 'Submit website review',
		omniWebMan: 'Website Management',

		transRecord: 'Transaction History',
		moneyFlow: 'Capital Flow',
		marginFlow: 'Deposit Flow',
		chargebackRecord: 'Chargeback History',
		chooseDate: 'Select date',
		date: 'Date',
		quicklySelect: 'Quick selection',
		today: 'Today',
		lastWeek: 'Last week',
		lastMonth: 'Last month',
		lastYear: 'Last year',
		searchWebOrder: 'Search website order number',
		transState: 'Status',
		transCurrency: 'Currency',
		searchTransFlow: 'Search Purchase Transaction ID',
		downloadRecord: 'CSV',
		businessType: 'Business Type',
		inOrOut: 'Income / expense',
		all: 'All',
		in: 'Income',
		out: 'Outgo',
		preAuthorizationConfirmationSuccess: 'Pre-authorization confirmation success',
		preAuthorizationConfirmationFailure: 'Pre-authorization confirmation failure',
		refundSuccess: 'Refund success',
		refundFailure: 'Refund failure',
		preAuthorizationSuccess: 'Pre-authorization success',
		preAuthorizationFailure: 'Pre-authorization failure',
		AuthorizationSuccess: 'authorization successfully',
		successPayment: 'Success payment',
		failedPayment: 'Failed payment',
		recordedPayment: 'Recorded payment',
		preAuthorizationCancellationSuccessfully: 'Pre-authorization cancellation successfully',
		preAuthorizationCancellationFailure: 'Pre-authorization cancellation failure',
		processing: 'Processing',
		reviewed: 'reviewed',
		cancelled: 'Cancelled',
		currency: 'Currency',
		transactionTime: 'Transaction Time',
		refundTime: 'Refund Time',

		transactionID: 'Flow ID',
		orderID: 'Merchant Transaction ID',
		omniOrderID: 'Merchant Transaction ID',

		shopifyOrderId: 'Shopify Transaction ID',

		client: 'Customer',
		merchantId: 'Customer ID',
		amount: 'Amount',
		status: 'Status',
		download: 'Download',
		moreDetail: 'more detail',
		change: 'change',
		settlementAmount: 'Settlement AmotradeStatusunt',
		inputTip: 'Please enter the withdrawal amount',
		Minimum: 'Minimum withdrawal amount RMB 100',
		// all: "All",
		replacement: 'Replacement of cash account',
		application: 'The application was successful',
		withdrawSuccessful: 'withdraw  successful',
		confirmChange: 'Confirm Change',

		depositAmount: 'Deposit Amount',
		checkRemittance: 'Check remittance',
		withdrawal: 'Withdrawal',
		copy: 'copy',
		websiteInforamtion: 'Website information',
		copyed: 'Copied to clipboard',
		copyfailed: 'Copy failed, please try again later',
		settlementNum: 'Your settlement amount now is',
		allFunds: 'All funds',
		paymentToday: 'No payment is remitted today',
		paymentTip: 'The estimated amount to remit to your bank account is ',
		withdrawalFee: 'Withdrawal Fee',
		estimatedTransferredAmount: 'Estimated Transferred Amount',
		confirm: 'Confirm',
		nodata: 'No data',
		transactionType: 'Transaction Type',
		threeDS: '3DS',
		token: 'Token',
		issueCountry: 'Card Bin Country',
		errorMessage: 'Error Message',
		threeDS2: '3DS',
		token2: 'Token',
		paymentBrand: 'Payment Method',
		createTime: 'Create Time',
		fixedFee: 'Fixed fee',
		attention: 'Attention!',
		attentionLine1: 'The actual amount you received may be different from the expected amount due to the service charges of the banks. The service charges is determined by the intermediary and receiving banks.',
		attentionLine2: 'When you make an international remittance, the intermediary and receiving banks may charge the transfer fee from you and the deposit fee from the payee which will be deducted from your remittance amount. If your remittance is returned by the beneficiary bank, the above fees will not be returned by banks. If you have any objection, please reach the intermediary bank, the beneficiary bank or the payee.',
		groupName: 'Group',
		storeName: 'Website',
		storeGroupName: 'Website/Group',
		omniStoreGroupName: 'Store/Website/Group',
		platformShareBenefitFee: 'Partner Fee',
		platformShareBenefitCurrency: 'Currency',
		pos: 'POS SN',
		mid: 'MID',
		tid: 'TID',
		rrn: 'RRN',
		tips: 'This transaction supports manual refund only. The following additional information is required.',
		tips2: 'Only the banks in the options support refunds.',
		bankName: 'Bank Name',
		accountName: 'Account Name',
		accountNumber: 'Account Number',
		paymentSlip: 'Bank Payment Slip',
		paymentSlipSample: 'Bank Payment Slip Sample',
		downloadPaymentSlip: 'download',
		tradeVoucherId: 'Transaction Reference',
		tradeVoucherIdSample: 'Please refer to the payment receipt sample for how to obtain the transaction reference number.',
		button: {
			confirm: 'Confirm',
			bind: 'Link',
			unbind: 'Unlink',
			cancel: 'Cancel',
			continue: 'Continue'
		}
	},
	withdrawModal: {
		formRules: 'The amount is greater than the withdrawal amount, please confirm and launch again',
		formRules2: 'Please enter the correct amount',
		refundRule: 'The amount is greater than the refundable amount, please confirm and launch again',
		success: 'success',
		failed: 'failed',
		add: 'Go add it',
		noWithdrawals: 'No Withdrawals',
		noAccount: 'No Withdrawal Account supported in this currency, please add it first'
	},
	tradeDetail: {
		webDetail: 'Website Details',
		tadeDetail: 'Transaction Details',
		refund: 'Refund',
		disbursement: 'Capture', // 预授权请款
		authVoid: 'Void', // 预授权撤销
		authVoidTip: 'Are you sure that you want to void this transaction for {0} {1}?',
		authCaptureTip: 'Are you sure that you want to capture this transaction for {0} {1}?',
		transactionStatus: 'Transaction Info',
		transactionInformation: 'Transaction Information',
		transactionTime: 'Transaction Time',
		paymentDetails: 'Payment Details',
		paymentMethod: 'Payment Method',
		cardNumber: 'Card Number',
		accountHolder: 'Account Holder',
		cardIssuingCountry: 'Card Issuing Country',
		preAuthorizationConfirmation: 'confirmation',
		preAuthorizationCancellation: 'cancellation',
		refundAccount: 'Refund account',
		refundAmount: 'Refund amount',
		refundFee: 'Refund fee',
		refundMargin: 'Refund deposit',

		orderAccount: 'Order recorded',
		totalAmount: 'Total amount',
		incomingAmount: 'incoming amount',
		fee: 'fee',
		securityDeposit: 'Deposit',
		amount: 'Amount',
		transactionCancelledSuccessfully: 'Transaction cancelled successfully',
		transactionCancellationfailed: 'Transaction cancellation failed',
		refunding: 'Refunding',
		riskReview: 'Waiting for risk review',
		inTransaction: 'Trading',
		totalConfirmation: 'Total amount of pre-authorization confirmation',
		totalRefundAmount: 'Total refund amount',

		transactionFee: 'transaction fee',
		refundFree2nd: 'Refund fee',
		accountfunds: 'Funds change in balance account',

		remainingAmount: 'Remaining refundable amount',
		refundTips1st: 'The refund you initiated here, the refund record will not be synced to your website. ',
		refundTips2nd: 'Please go to your website to initiate a refund.',
		refundTips3nd: 'Please provide bank information because this transaction can not be refunded to original way',
		captureTips1st: 'The capture you initiated here, the capture record will not be synced to your website.',
		captureTips2nd: 'Please go to your website to initiate a capture.',
		accountName: 'Account Name',
		accountNumber: 'Account Number',
		bankCode: 'Bank Code',
		remainAmount: 'The remaining identifiable amount of this transaction',
		confirmPayment: 'It cannot be recovered if it is canceled.',
		cinfirmCancel: 'Do you confirm to cancel the payment? ',
		cancelPayment: 'Cancel the payment',
		cancelStatus: 'Cancel success',
		riskOrder: 'Risky orders might cause chargeback disputes which will affect your business. Do you confirm to accept it?',
		riskReviews: 'The transaction is waiting for PingPong\'s review',
		riskReviewC: 'The transaction is waiting for merchant\'s review',
		cancelFont: 'Do you confirm to cancel the payment? It cannot be recovered if it is canceled.',
		risky: 'Please review the risky transaction',
		riskyTips1: 'Please confirm with the card holder before ',
		riskyTips2: 'or the transaction will be automatically cancelled.',
		accept: 'Accept',
		cancel: 'Cancel',
		cancelDeal: 'Cancel the payment',
		riskOrderReject: 'Risk order review rejection',
		appeal: 'Waive appeal',
		appealFont: 'Are you sure you want to discard your appeal? After giving up, you will not be able to appeal again. Please make a careful decision.',
		cancelAppeal: 'cancel',
		chargeBackTip: 'No refund in case of chargeback',
		refundOrderId: 'Refund Transaction ID',
		storeRefundFlowId: 'Merchant Refund Transaction ID',
		omniStoreRefundFlowId: 'Merchant Refund Transaction ID',

		origintransactionId: 'Purchase Transaction ID',
		shippingAddress: 'Shipping Address',
		shippingPhone: 'Shipping Phone',
		email: 'Shipping Email',
		issue: 'Issue Bank',
		moreDetail: 'more details'
	},
	capitalFlow: {
		all: 'All',
		Payment: 'Payment',
		paymentFee: 'Payment fee',
		reserveHolding: 'Rolling Reserve',
		refund: 'Refund',
		refundFee: 'Return fee',
		depositRelease: 'Rolling Reserve Release For Refund',
		depositExpireRelease: 'Rolling Reserve Expired Release',
		chargebackDeduction: 'Chargeback deduction',
		chargebackCancellation: 'Chargeback Cancellation',
		chargebackFee: 'Chargeback fee',
		chargebackSuppFee: 'Chargeback Step-rate Fee',
		withdrawal: 'Withdrawal',
		withdrawalFee: 'Withdrawal fee',
		depositReleaseCancellation: 'Rolling Reserve Expired Release Cancel',
		flowID: 'Flow ID',
		time: 'Time',
		incomingAmount: 'Incoming amount',
		outcomingAmount: 'Outcoming amount',
		accountBalance: 'Account balance',
		businessType: 'Business Type',
		chargebackArbitrationFee: 'ChargeBack Arbitration Fee',
		chargebackReturn: 'Chargeback Arbitration Fee Retrun'
	},
	depositFlow: {
		incomingDeposit: 'Incoming deposit',
		depositReleaseForRefund: 'Deposit release for refund',
		depositBalance: 'Deposit expire release'
	},
	chargeBack: {
		appealDate: 'Appeal Date',
		chargebackDate: 'Chargeback Date',
		chargebackFlowID: 'Chargeback Flow ID',
		transactionID: 'Purchase Transaction ID',
		appealStatus: 'Appeal Status',
		search: 'Search',
		cardNumber: 'Card number',
		chargebackReason: 'Chargeback reason',
		amount: 'Amount',
		currency: 'Currency',
		transactionTime: 'Transaction Time',
		chargebackAmount: 'Chargeback amount',
		chargebackCurrency: 'Chargeback Currency',
		operation: 'Operation',
		chargebackAppeal: 'Chargeback Appeal',
		chargebackCase: 'Do you confirm to appeal the chargeback case?',
		startDate: 'Start time',
		endDate: 'End time'
	},
	tradeType: {
		debit: 'DEBIT',
		refund: 'REFUND',
		auth: 'AUTH',
		capture: 'CAPTURE',
		void: 'VOID',
		authCapture: 'CAPTURE',
		approve: 'APPROVE',
		reject: 'REJECT',
		processing: 'PROCESSING',
		pending: 'PENDING',
		success: 'SUCCESS',
		failed: 'FAILED',
		canceled: 'CANCELED',
		review: 'REVIEW',
		tradeTime: 'Transaction Time',
		tradeType: 'Transaction Type',
		tradeStatus: 'Status',
		operator: 'operator',
		exportExcel: 'Export current results',
		tableField: 'Set table display fields',
		fixedField: 'Fixed field',
		optionalField: 'Optional field',
		saveSeting: 'Save Settings',
		yes: 'yes',
		no: 'no',
		save: 'Saved successfully',
		savefaile: 'Save failed',
		risky: 'The transaction is risky, please review',
		riskyTips1: 'Please contact the cardholder for confirmation before',
		riskyTips2: 'the transaction will be automatically cancelled if it expires',
		accept: 'Accept transaction',
		cancel: 'Cancel the deal',
		currentDetails: 'Current details',
		details: 'details',
		tradeNum: 'Flow ID',
		refundNum: 'Refund Transaction ID',
		riskOrder: 'Risk orders may have a subsequent chargeback, affecting your business, whether the order is confirmed to be risk-free',
		riskReviews: 'Transaction risky,  waiting for PingPong review',
		riskReviewC: 'Transaction is risky, waiting for seller review',
		cancelFont: 'Whether to confirm the cancellation of this order, once the transaction is cancelled, it cannot be resumed',
		arn: 'ARN',
		failReason: 'Failure Cause',
		failCode: 'Error Code'
	},
	tradeChannelRefund: {
		areaCode: 'Area code',
		areaCodeRequired: 'Please select area code',
		accountType: 'Type',
		accountName: 'Account Name',
		accountHolder: 'Account Holder',
		accountNumber: 'Account Number',
		email: 'Email',
		phoneNo: 'Phone number',
		phoneRequired: 'Please enter phone number',
		nationalId: 'National Id'
	},
	storeOnboarding: {
		title: 'Store Status',
		mcc: 'MCC',
		storeStatus: 'Store Status',
		location: 'Location',
		submerchantId: 'Submerchant ID',
		submerchantName: 'Submerchant Name',
		storeUrl: 'Store URL',
		businessIdentityNumber: 'Business Identity Number',
		businessAddress: 'Business Address',
		brand: 'Brand Name',
		createTime: 'Creation Time',
		updateTime: 'Update Time',
		search: 'Search',
		reset: 'Reset',
		all: 'ALL',
		close: 'Unavailable',
		open: 'Available'
	}
}

export default en
